import { BaseView } from "@nolimitcity/slot-game/bin/core/base/BaseView";
import { Point, Graphics } from "pixi.js";
import { TimelineMax, TweenLite, Timeline } from "gsap";
import { ResizeHelper , IDimConfig, LayoutDimData } from "@nolimitcity/slot-game/bin/core/utils/ResizeHelper";
import { EventHandler } from "@nolimitcity/slot-game/bin/core/event/EventHandler";
import { GameEvent } from "@nolimitcity/slot-game/bin/core/event/GameEvent";
import { StageManager } from "@nolimitcity/slot-game/bin/core/stage/StageManager";
import { SanGameConfig } from "../../../SanGameConfig";
import { SpinEvent } from "@nolimitcity/slot-game/bin/core/spin/event/SpinEvent";
import { Helper } from "@nolimitcity/slot-game/bin/core/utils/Helper";
import { PosterPlayerConfig, PosterPlayer } from "./PosterPlayer";
import { Translation } from "@nolimitcity/slot-game/bin/core/translation/Translation";
import { TranslationConfig } from "../../../translation/TranslationConfig";
import { TextStyleOptions } from "@nolimitcity/slot-game/bin/core/text/TextStyleOptions";
import { WinCounter } from "../countup/WinCounter";
import { TextStyleConfig } from "../../../translation/TextStyleConfig";
import { SlotGame } from "@nolimitcity/slot-game/bin/core/SlotGame";
import { SanQuentin } from "../../../SanQuentin";

export class FeaturePosterState {
    public static readonly MINI_FEATURE = "mini_feature";
    public static readonly FS_FEATURE = "fs_feature";
}

export class NoWinPosterState {
    public static readonly NO_WIN = "No_Win";

    public static readonly NO_WIN_BREAD = "Not_Much";
    public static readonly NO_WIN_CIGS = "Fish";
    public static readonly NO_WIN_PAPER = "No_Good";

    public static readonly NO_WIN_AGAIN = "Not_Again";
    public static readonly NO_WIN_INSANE = "Insane";
    public static readonly NO_WIN_SHIT = "Shit";
}

export class BigWinPosterState {
    public static readonly BIG_WIN = "bigWin";

    public static get JuriGFXUSSettings():boolean {
        if(SlotGame.api.gameClientConfiguration.useCensoredGfxUS === undefined){
            return SlotGame.api.gameClientConfiguration.jurisdictionName === "US-WV";
        }
        return SlotGame.api.gameClientConfiguration.useCensoredGfxUS;
    }

    public static bigWinTypeLvl(lvl:number):string{
        const cLvl = Math.min(lvl+1,5);
        if(this.JuriGFXUSSettings && (cLvl === 3 || cLvl === 4)){
            return "Big_Win_"+cLvl + "_WV";
        }else{
            return "Big_Win_"+cLvl;
        }
    }
}

export class PosterManager extends BaseView {

    public get dim():LayoutDimData{ return ResizeHelper.calcDim(this.PosterDim); };

    private PosterDim:IDimConfig = {
        dimOrientation : {
            landscape :{
                scale:      new Point( 1, 1),
                position:   new Point( 360, 360),
                layout :{
                    left:   new Point( 360, 360),
                    right:  new Point( 360, 360)
                }
            },
            portrait :{ 
                scale:      new Point( 1, 1),
                position:   new Point( 360, 220)
            }
        },
        WIDTH: 1440,
        HEIGHT: 900,
    };
    
    private static _instance:PosterManager;

    private player:PosterPlayer;// = new PosterPlayer([FeaturePosterState.MINI_FEATURE,FeaturePosterState.FS_FEATURE]);
    private blackGraphics:Graphics;

    protected totalWinText:PIXI.Text;

    private timeline:TimelineMax;
    private timelineBlack:TimelineMax;
    private _onClickCB:Function;

    public static get instance():PosterManager{
        return this._instance;
    }

    constructor(){ super() 
        if(PosterManager._instance) {
            debugger;
            throw new Error("Error: Currency.constructor() - Instantiation failed: Singleton.");
        }else{
            PosterManager._instance = this;
            StageManager.getLayer(SanGameConfig.instance.LAYERS.POSTER.name).addChild(this);
        }
    };

    protected initAnimations():void{

        this._onClickCB = () => EventHandler.dispatchEvent(new GameEvent(SpinEvent.SKIP));
        this.createGraphics();

        this.player = new PosterPlayer();

        this.player.load([
            FeaturePosterState.MINI_FEATURE,
            FeaturePosterState.FS_FEATURE,

            NoWinPosterState.NO_WIN,
            BigWinPosterState.BIG_WIN,
        ]).forEach(p => {
            this.addChild(p.post.obj);
            p.post.obj.visible = false;
        });

        this.totalWinText = this.createText(Translation.translate(TranslationConfig.TOTAL_WIN), TextStyleConfig.TOTAL_WIN);
    }

    private createText(text:string, style:TextStyleOptions):PIXI.Text {
        const textField = new PIXI.Text(text, style);
        textField.style.align = "center";
        textField.anchor.set(0.5, 0.5);
        textField.alpha = 0;
        this.addChild(textField);
        return textField;
    }

    private totalWinTl:TimelineMax;

    public playTotalWin(value:number, isWinBelowStake:boolean):TimelineMax{

        this.totalWinTl = Helper.timeLineKiller(this.totalWinTl, new TimelineMax());

        this.totalWinText.visible = !isWinBelowStake;
        this.totalWinText.text = Translation.translate(TranslationConfig.TOTAL_WIN);// + "    " + Currency.formatValue(value);
        while(this.totalWinText.width > 500) this.totalWinText.style.fontSize--;

        this.totalWinTl.add(() => WinCounter.normalCounter.playTotalWin(value,true))
        this.totalWinTl.fromTo(this.blackGraphics,0.2,{alpha:0},{alpha:0.7},0)
        this.totalWinTl.fromTo(this.totalWinText,0.2,{alpha:0},{alpha:1},0)
        this.totalWinTl.to(this,2,{});
        
        return this.totalWinTl;
    }

    public stopTotalWin():TimelineMax{
        this.totalWinTl = Helper.timeLineKiller(this.totalWinTl, new TimelineMax());

        this.totalWinTl.add([
            TweenLite.to(this.totalWinText,0.5,{alpha:0}),
            TweenLite.to(this.blackGraphics,0.5,{alpha:0}),
            () => WinCounter.normalCounter.playTotalWin(0,false)//abort(),
        ]);

        return this.totalWinTl;
    }

    public playManiac(fadeIn:number = 0.2, conf?:PosterPlayerConfig):TimelineMax{
        this.player.poster("bigWin");
        this.timeline = Helper.timeLineKiller(this.timeline, new TimelineMax());
        this.timeline.add(this.player.play(conf));
        this.timeline.fromTo(this.player.playingPoster!,fadeIn,{alpha:0},{alpha:1},0)
        return this.timeline;
    }

    public play(state:string, fadeIn:number = 0.3, conf?:PosterPlayerConfig):TimelineMax{
        this.player.poster(state);
        this.timeline = Helper.timeLineKiller(this.timeline, new TimelineMax(),true);
        this.timeline.add(this.player.play(conf));
        this.timeline.fromTo(this.blackGraphics,fadeIn,{alpha:0},{alpha:0.4},0)
        if(this.player.playingPoster!)
            this.timeline.fromTo(this.player.playingPoster!,fadeIn,{alpha:0},{alpha:1},0)
        return this.timeline;
    }

    public stopSwitchBig():void{
        this.timeline = Helper.timeLineKiller(this.timeline);
        this.player.stop();
    }

    public stopTotal(fadeout:number= 0.3 ):TimelineMax{
        this.timeline = Helper.timeLineKiller(this.timeline, new TimelineMax({
            onUpdate:() => {
                if(this.player.playingPoster)
                    this.player.playingPoster.alpha = 1-this.timeline.progress();
            },
            onComplete:() => {  
                this.player.stop();
                if(this.player.playingPoster)
                    this.player.playingPoster.alpha = 0;
            }
        }));
        return this.timeline;
    }
    
    public stop(fadeout:number= 0.3 ):TimelineMax{
        this.timeline = Helper.timeLineKiller(this.timeline, new TimelineMax({
            onUpdate:() => {
                if(this.player.playingPoster)
                    this.player.playingPoster.alpha = 1-this.timeline.progress();
            },
            onComplete:() => {  
                this.player.stop();
                if(this.player.playingPoster)
                    this.player.playingPoster.alpha = 0;
            }
        }));
        this.timeline.fromTo(this.blackGraphics,fadeout,{alpha:.4},{alpha:0},0)
        return this.timeline;
    }

    public setBlackScreenAlpha(to:number,duration:number = 0.3):TimelineMax{
        this.timelineBlack = Helper.timeLineKiller(this.timelineBlack,new TimelineMax());
        this.timelineBlack.to(this.blackGraphics,duration,{alpha:to});
        return this.timelineBlack;
    }

    private createGraphics():void{
        this.blackGraphics = new Graphics();
        this.blackGraphics.alpha = 0;
        this.blackGraphics.interactive = false;
        this.blackGraphics.buttonMode = false;

        this.blackGraphics.beginFill( 0x000000, 1);
        this.blackGraphics.drawRect(-this.PosterDim.WIDTH,-this.PosterDim.HEIGHT,this.PosterDim.WIDTH*2, this.PosterDim.HEIGHT*2);
        this.blackGraphics.endFill();

        this.blackGraphics.on('pointerdown', () => this._onClickCB());
        this.addChild(this.blackGraphics);
    }

    public setInteractive(value:boolean){
        this.blackGraphics.interactive = value;
        this.blackGraphics.buttonMode = value;
        this.buttonMode = value;
        this.interactive = value;
    }

    protected onResize(){
        if(this.blackGraphics === undefined) this.initAnimations();// return;
        this.totalWinText.y = ResizeHelper.IsLandscape()? -225 : -150;

        this.position = this.dim.position;  
        this.scale = this.dim.scale;
    }
}